<template>
    <div class="rkm-content-header">
        <div class="rkm-content-header-title"> 
            <div v-if="!$slots.title">{{ title }}</div>
            <slot v-else name="title" />
        </div>

        <div
            v-if="$slots.actions"
            class="rkm-content-header-actions"
        >
            <slot name="actions" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {type: String},
    },
}
</script>

<style scoped>
.rkm-content-header {
    align-items: flex-end;
    background: #ffffff;
    border-bottom: 1px solid #dfdfdf;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    padding: 14px 10px;
    position: sticky;
    top: 56px;
    width: 100%;
    z-index: 901;
}
.rkm-content-header-title {
    font-size: 24px;
}
</style>